import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";

import AccountLevel2PrimaryVerification from "./AccountLevel2PrimaryVerification";
import AccountLevel2Verification from "./AccountLevel2Verification";
import AccountLevel3Verification from "./AccountLevel3Verification";
import AccountVerification from "./AccountVerification";

const AccountVerificationIndex = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={AccountVerification} />
      <ProtectedRoute
        path={`${path}/level2`}
        component={AccountLevel2Verification}
      />
      <ProtectedRoute
        path={`${path}/level2-upload`}
        component={AccountLevel2PrimaryVerification}
      />
      <ProtectedRoute
        path={`${path}/level3`}
        component={AccountLevel3Verification}
      />
    </Switch>
  );
};

export default AccountVerificationIndex;
